import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import humetaLogo from "assets/svg/humeta_logo.svg"
import shortLogo from "assets/images/shot-logo-new.jpg"

type LogoState = {
  logoUrl: any;
  smallLogo: any;
  defaultHumeta: boolean
};

const initialState: LogoState = {
  logoUrl: humetaLogo,
  smallLogo: shortLogo,
  defaultHumeta: true
};

const logoSlice = createSlice({
  name: "logo",
  initialState,
  reducers: {
    setLogo: (state, action: PayloadAction<any>) => {
      state.logoUrl = action.payload;
      localStorage.setItem("bigLogo", action.payload)
    },
    setSmallLogo: (state, action: PayloadAction<any>) => {
      state.smallLogo = action.payload;
      localStorage.setItem("smallLogo", action.payload)
    },
    setDefaultHumeta: (state, action: PayloadAction<boolean>) => {
      state.defaultHumeta = action.payload;
      localStorage.setItem("default", `${action.payload}`)
    },
    resetLogo: () => initialState,
  },
});

export const { setLogo, setSmallLogo, setDefaultHumeta, resetLogo } = logoSlice.actions;
export default logoSlice.reducer;

// Selectors
export const selectLogo = (state: RootState) => state.logo.logoUrl;
export const selectSmallLogo = (state: RootState) => state.logo.smallLogo;
export const isDefaultHumeta = (state: RootState) => state.logo.defaultHumeta;
